import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IFlipIconProps extends IConDefaultType {}

function FlipIcon({ color, className, size = 24, rotate, flip }: IFlipIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 1.65533L11.2197 6.375C11.5126 6.66789 11.9874 6.66789 12.2803 6.375C12.5732 6.08211 12.5732 5.60723 12.2803 5.31434L7.2955 0.329505C6.85616 -0.109834 6.14385 -0.109836 5.70451 0.329505L0.71967 5.31434C0.426777 5.60723 0.426777 6.08211 0.71967 6.375C1.01256 6.66789 1.48744 6.66789 1.78033 6.375L6.5 1.65533Z"
          fill={color || theme.color.icon.icon_3}
        />
      </svg>
    </i>
  );
}

export default FlipIcon;
